/**
 * 偵測後端回的 symbol_delisted 軟錯誤 (HTTP 404 + { error: 'symbol_delisted', ... }).
 * fetchJSON throw 的 Error.message 形如：`HTTP 404: {"error":"symbol_delisted",...}`
 */
export function isDelistedError(err: unknown): boolean {
  if (!err) return false;
  const msg = err instanceof Error ? err.message : String(err);
  return /symbol_delisted/i.test(msg)
    || /no data found/i.test(msg)
    || /symbol may be delisted/i.test(msg)
    || /quote not found for symbol/i.test(msg);
}

export const DELISTED_MESSAGE = '此代號疑似下市 / 暫停交易，無資料';
